import { ContributionPublic } from '../../../../../common/model/input/contributions/types';
import { Action } from '../../actions/actions';
import { EntityWithContribution } from './types';

export interface ContributionTree {
  contributions: {
    [id: number]: ContributionPublic | undefined;
  };
  /**
   * All of these should be ordered so that the latest contribution is first.
   */
  companyContributions: {
    [companyId: string]: number[] | undefined;
  };
  productContributions: {
    [productId: string]: number[] | undefined;
  };
  userContributions: {
    [userId: string]: number[] | undefined;
  };
  latestContributions?: number[];
}

export const initialContributionState: ContributionTree = {
  contributions: {},
  companyContributions: {},
  productContributions: {},
  userContributions: {},
};

export function reducer(state = initialContributionState, action: Action): ContributionTree {
  switch (action.type) {
    case 'CONTRIBUTION/STORE':
      if (action.payload.contributions.length > 0) {
        const newContributions = action.payload.contributions.reduce<ContributionTree['contributions']>(
          (result, contribution) => {
            result[contribution.id] = contribution;
            return result;
          },
          {},
        );

        return {
          ...state,
          contributions: {
            ...state.contributions,
            ...newContributions,
          },
        };
      }

      return state;
    case 'CONTRIBUTION/APPEND_FOR_ENTITY':
      if (action.payload.type === EntityWithContribution.COMPANY) {
        return {
          ...state,
          companyContributions: {
            ...state.companyContributions,
            [action.payload.id]: [
              ...action.payload.contributions,
              ...(state.companyContributions[action.payload.id] || []),
            ],
          },
        };
      }

      if (action.payload.type === EntityWithContribution.PRODUCT) {
        return {
          ...state,
          productContributions: {
            ...state.productContributions,
            [action.payload.id]: [
              ...action.payload.contributions,
              ...(state.productContributions[action.payload.id] || []),
            ],
          },
        };
      }

      if (action.payload.type === EntityWithContribution.USER) {
        return {
          ...state,
          userContributions: {
            ...state.userContributions,
            [action.payload.id]: [
              ...action.payload.contributions,
              ...(state.userContributions[action.payload.id] || []),
            ],
          },
        };
      }

      console.warn('Unknown contribution type', action.payload.type);
      return state;
    case 'CONTRIBUTION/APPEND_LATEST':
      return {
        ...state,
        latestContributions: [...action.payload.contributions, ...(state.latestContributions || [])],
      };
    case 'USER/LOGGED_OUT':
      return {
        ...state,
        userContributions: {},
      };
  }

  return state;
}
